export default {
      id: "menu__driver_fill-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.svg#menu__driver_fill",
      toString: function () {
        return this.url;
      }
    }